import { useMemo } from 'react'

export const useE2Etest = () => {
  const isE2Etest = useMemo(() => !!window.isPlaywright, [])
  return isE2Etest
}
